import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Left from '@/images/position/align/Left.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { alignElementsLeft } from '../../../../actions/align/Left';

export const LeftMenuItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        alignElementsLeft(selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Left} text="Left" />;
};
